import { RoleModal } from "../../role/modal/role-modal";

export class VendorDetailModal {
    id: number;
    firstName: string;
    lastName: string;
    designation: string;
    phoneNo: number;
    secondaryPhoneNo: number;
    email: string;
    altPhoneNo: number;
    userName:string;
    password:string;
    experience: string;
    title: string;
    role : RoleModal;
  }
  